"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const prop_types_1 = __importDefault(require("prop-types"));
const get_css_1 = __importDefault(require("../get-css"));
exports.propTypes = {
    overflow: prop_types_1.default.string,
    overflowX: prop_types_1.default.string,
    overflowY: prop_types_1.default.string
};
exports.propAliases = {
    overflow: ['overflowX', 'overflowY']
};
exports.propValidators = {};
const overflowY = {
    className: 'ovflw-y',
    cssName: 'overflow-y',
    jsName: 'overflowY',
    safeValue: true
};
const overflowX = {
    className: 'ovflw-x',
    cssName: 'overflow-x',
    jsName: 'overflowX',
    safeValue: true
};
exports.propEnhancers = {
    overflowX: (value) => get_css_1.default(overflowX, value),
    overflowY: (value) => get_css_1.default(overflowY, value)
};
//# sourceMappingURL=overflow.js.map